import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useContext, useState, useEffect } from "react";
import { Redirect } from "react-router";
import { toast } from "react-toastify";
import { loginRequest } from "../configs/msalConfig";
import { toastConfig } from "../configs/toastConfig";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";
import { isMobile, getUA, deviceType, deviceDetect } from "react-device-detect";
import { releaseDateLabel } from "../configs/config.json";
import { dashboard } from "../configs/routes";
// import { getCurrentAppVersion } from "../services/mobileService.js";
import { decodeJwt } from "jose";
import {
	loadB2CEmail,
	logout,
	loadAutoLoginToken,
	saveAutoLoginToken,
	loadDashToken,
	loadAutoLogin,
	clearLocalStorage,
} from "../services/authService";
import { login, getConsent } from "../services/dashApiService";
import { hasInternetConnection } from "../services/systemService";
import {
	loadUserPid,
	loadUserSettings,
	getDiseaseGroup,
	setDiseaseGroup,
	setIsDemoUser,
	setIsRegistrar,
	setAppSettings,
	setIsLoggedIn,
} from "../services/userService";

export default function StartButton({ forceRefresh }) {
	const { instance, accounts } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	const [lastLogin, setLastLogin] = useState();
	const [isComplete, setIsComplete] = useState(false);
	const [isEnabled, setIsEnabled] = useState(true);
	const [demoUser, setDemoUser] = useState(false);
	const [userDetails, setUserDetails] = useState({});
	const [consentConfirmed, setConsentConfirmed] = useState(false);

	const setButtonEnabled = (value) => {
		setIsEnabled(value);
	};

	const { theme } = useContext(DiseaseGroupContext);

	useEffect(() => {
		if (isComplete) {
			forceRefresh();
		}
	}, [isComplete, forceRefresh]);

	const handleStart = (
		instance,
		accounts,
		isAuthenticated,
		setButtonEnabled
	) => {
		if (hasInternetConnection()) {
			setButtonEnabled(false);

			const standardLogin = () => {
				if (isAuthenticated === true) {
					const msalAccount = instance.getActiveAccount() ?? accounts[0];

					const acquireTokenRequest = { ...loginRequest, account: msalAccount };

					const email = loadB2CEmail();

					if (email) {
						acquireTokenRequest.loginHint = email;
					}

					instance
						.acquireTokenSilent(acquireTokenRequest)
						.catch((error) => {
							console.error(error);
							logout(instance, accounts[0]);
						})
						.then(() => {
							setButtonEnabled(true);
						});
				} else {
					const sStore = window["sessionStorage"];
					if (sStore) {
						sStore.clear();
					}

					const diseaseGroup = getDiseaseGroup();

					// localStorage.clear();
					clearLocalStorage();
					if (diseaseGroup) {
						setDiseaseGroup(diseaseGroup);
					}

					instance
						.loginRedirect({
							...loginRequest,
							prompt: "login",
						})
						.catch((error) => {
							console.error(error);
							toast.error(
								"An error occurred trying to log in, please try again",
								{
									toastId: toastConfig.toastIds.errLogin,
								}
							);
						})
						.then(() => {
							setButtonEnabled(true);
						});
				}
			};

			const autoLoginToken = loadAutoLoginToken();
			if (autoLoginToken && loadAutoLogin()) {
				const data = {
					isMobile,
					getUA,
					deviceType,
					deviceDetect: deviceDetect(getUA),
					releaseDateLabel,
					version: "",
					autoLogin: true,
				};

				login(autoLoginToken, data)
					.then((loginData) => {
						setIsLoggedIn(true);
						setIsDemoUser(loginData.data.isDemoUser);
						setDemoUser(loginData.data.isDemoUser);
						setAppSettings(loginData.data.appSettings);
						setIsRegistrar(decodeJwt(loadDashToken())?.registrar ?? false);
						saveAutoLoginToken(loginData.data.autoLoginToken);

						const diseaseGroup = loginData.data.diseaseGroup;

						if (diseaseGroup) {
							setDiseaseGroup(diseaseGroup);
						}

						setLastLogin(loginData.data.lastLogin);

						// do we want to display any message
						if (loginData.data.message) {
							toast(
								loginData.data.message.message,
								loginData.data.message.options || {}
							);
						}

						const promises = [getConsent(), loadUserPid(), loadUserSettings()];

						promises[0].then((consentData) => {
							if (consentData.data.consentConfirmed) {
								setConsentConfirmed(true);
							}
						});

						promises[1].then((data) => {
							if (data.success === true) {
								setUserDetails(data.data);
							}
						});

						// loadUserSettings();

						Promise.all(promises)
							.then(() => {
								setIsComplete(true);
								setIsLoggedIn(true);
							})
							.catch((err) => {
								console.log("Inner error", err);
								standardLogin();
							});
					})
					.catch((err) => {
						console.log("Outer error", err);
						standardLogin();
					});
			} else {
				standardLogin();
			}
		} else {
			toast.error("There is no internet connection available", {
				toastId: toastConfig.toastIds.errNetwork,
			});
		}
	};

	if (isComplete) {
		let pathname = "";
		let state = {};

		switch (true) {
			case consentConfirmed && lastLogin:
				pathname = dashboard;
				state = { isDemoUser: demoUser };
				break;

			case consentConfirmed:
				pathname = "/loadingdata";
				state = { isDemoUser: demoUser };
				break;

			default:
				pathname = "/setup";
				state = { userDetails };
				break;
		}

		return (
			<Redirect
				to={{
					pathname,
					state,
				}}
			/>
		);
	} else {
		return (
			<>
				<button
					disabled={isEnabled === false}
					onClick={() =>
						handleStart(instance, accounts, isAuthenticated, setButtonEnabled)
					}
					className={`mx-auto text-center text-white ${theme.button().bg()} ${
						isEnabled === true ? "" : "bg-opacity-50"
					} p-3 rounded-lg w-48 sm:w-64 text-xl block flex-shrink`}
				>
					{isEnabled === true ? "Sign in..." : "Please Wait..."}
				</button>
			</>
		);
	}
}
